const progressMessages = [
    "Processing. Thank you for your patience.", // Small latency.
    "Processing still in progress. Thank you for waiting.", // High latency.
    "Thank you for your patience. Processing still in progress and should complete shortly."]; // Critical latency.

export const showBlocker = {
    methods: {
        showSmallLatencyMessage() {
            this.setLoadingStatus({
                showSpinner: true,
                showBlocker: true,
                showMessage: true,
                loadingMessage: progressMessages[0]
            });
        },
        showHighLatencyMessage() {
            this.setLoadingStatus({
                showSpinner: true,
                showBlocker: true,
                showMessage: true,
                loadingMessage: progressMessages[1]
            });
            this.$timer.stop("showSmallLatencyMessage");
        },
        showCriticalLatencyMessage() {
            this.setLoadingStatus({
                showSpinner: true,
                showBlocker: true,
                showMessage: true,
                loadingMessage: progressMessages[2]
            });
            this.$timer.stop("showHighLatencyMessage");
        },
        showBlockerWithNoSpinner() {
            this.setLoadingStatus({
                showSpinner: false,
                showBlocker: true
            });
        },
        showBlockerWithSpinner() {
            this.setLoadingStatus({
                showSpinner: true,
                showBlocker: true
            });
        },
        startProgressIndicator() {
            this.setLoadingStatus(true);

            this.$timer.start("showSmallLatencyMessage");
            this.$timer.start("showHighLatencyMessage");
            this.$timer.start("showCriticalLatencyMessage");
        },
        stopProgressIndicator() {
            this.setLoadingStatus(false);

            this.$timer.stop("showSmallLatencyMessage");
            this.$timer.stop("showHighLatencyMessage");
            this.$timer.stop("showCriticalLatencyMessage");
        }
    },
    timers: {
        showSmallLatencyMessage: {
            time: 8000
        },
        showHighLatencyMessage: {
            time: 20000
        },
        showCriticalLatencyMessage: {
            time: 40000
        }
    }
}